<template>
    <div class="sitePage">
        <!--国控站点-->
        <div class="nav">
            <div class="item timeC">
                <!--时间选择-->
                <el-date-picker
                        size="mini"
                        v-model="queryParam.times"
                        type="datetimerange"
                        @change="datePickerChange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <div class="Range">
                <div class="item time"
                     v-for="(item,index) in timeList"
                     :class="item.value===queryParam.timeType ? 'active' :''"
                     @click="navTimeChange(item)"
                     :key="index">
                    {{item.label}}
                </div>
            </div>

            <!--<div class="Range">-->
            <!--<div class="item time"-->
            <!--v-for="(item,index) in timeRangeList"-->
            <!--:class="item.value===queryParam.timeRange ? 'active' :''"-->
            <!--@click="navTimeRangeChange(item)"-->
            <!--:key="index">-->
            <!--{{item.label}}-->
            <!--</div>-->
            <!--</div>-->

            <div class="center"></div>
            <!--<div class="tabname">{{queryParam.times[0]}} 至 {{queryParam.times[1]}} 宿州市AQI</div>-->
            <!--<div class="item btn" @click="getSiteList">查询</div>-->
            <!--<div class="item btn" @click="exportExcel">导出</div>-->
            <a-button class="btn" type="primary" size="small" @click="getSiteList">查询</a-button>
            <a-button class="btn" type="primary" size="small" @click="exportExcel">导出</a-button>

        </div>
        <div class="content siteTable">


            <div class="aqibox noFloat">
                <div class="table_title">
                    <div class="tabname">{{queryParam.times[0]}} 至 {{queryParam.times[1]}} 宿州市</div>
                    <div class="titletab">
                        <table class="table table-bordered table-hover info tabletitle" style="font-size:14px;"
                               border="2">
                            <tbody>
                            <tr>
                                <td rowspan="2" style="width:10.5%;">
                                    <span>
                                        时间
                                    </span>
                                    <span>
                                        <i class="icon-jiantou"
                                           :class="queryParam.orderName==='time'&&queryParam.order=='1' ? 'active' :''"
                                           @click="iChange('time','1')"></i>
                                        <i class="icon-jiantouxia"
                                           :class="queryParam.orderName==='time'&&queryParam.order=='0' ? 'active' :''"
                                           @click="iChange('time','0')"></i>
                                    </span>
                                </td>
                                <td rowspan="2" style="width:10.5%;">
                                    <span>
                                        站点
                                    </span>
                                </td>
                                <td colspan="2" style="width:9.5%;">PM<sub>2.5</sub></td>
                                <td colspan="2" style="width:9.5%;">PM<sub>10</sub></td>
                                <td colspan="2" style="width:9.5%;">SO<sub>2</sub></td>
                                <td colspan="2" style="width:9.5%;">NO<sub>2</sub></td>
                                <td colspan="2" style="width:9.5%;">CO</td>
                                <td colspan="2" style="width:9.5%;">O<sub>3</sub></td>
                                <td colspan="3" style="width:22%;">AQI</td>
                            </tr>
                            <tr>
                                <td style="width:4.75%;">
                                    <span>
                                        浓度
                                    </span>
                                    <span>
                                        <i class="icon-jiantou"
                                           :class="queryParam.orderName==='pm25Nd'&&queryParam.order=='1' ? 'active' :''"
                                           @click="iChange('pm25Nd','1')"></i>
                                        <i class="icon-jiantouxia"
                                           :class="queryParam.orderName==='pm25Nd'&&queryParam.order=='0' ? 'active' :''"
                                           @click="iChange('pm25Nd','0')"></i>
                                    </span></td>
                                <td style="width:4.75%;">
                                        <span>
                                        IAQI
                                    </span>
                                    <span>
                                         <i class="icon-jiantou"
                                            :class="queryParam.orderName==='pm25Iaqi'&&queryParam.order=='1' ? 'active' :''"
                                            @click="iChange('pm25Iaqi','1')"></i>
                                        <i class="icon-jiantouxia"
                                           :class="queryParam.orderName==='pm25Iaqi'&&queryParam.order=='0' ? 'active' :''"
                                           @click="iChange('pm25Iaqi','0')"></i>
                                    </span>
                                </td>
                                <td style="width:4.75%;">
                                       <span>
                                        浓度
                                    </span>
                                    <span>
                                         <i class="icon-jiantou"
                                            :class="queryParam.orderName==='pm10Nd'&&queryParam.order=='1' ? 'active' :''"
                                            @click="iChange('pm10Nd','1')"></i>
                                        <i class="icon-jiantouxia"
                                           :class="queryParam.orderName==='pm10Nd'&&queryParam.order=='0' ? 'active' :''"
                                           @click="iChange('pm10Nd','0')"></i>
                                    </span>
                                </td>
                                <td style="width:4.75%;">
                                        <span>
                                        IAQI
                                    </span>
                                    <span>
                                         <i class="icon-jiantou"
                                            :class="queryParam.orderName==='pm10Iaqi'&&queryParam.order=='1' ? 'active' :''"
                                            @click="iChange('pm10Iaqi','1')"></i>
                                        <i class="icon-jiantouxia"
                                           :class="queryParam.orderName==='pm10Iaqi'&&queryParam.order=='0' ? 'active' :''"
                                           @click="iChange('pm10Iaqi','0')"></i>
                                    </span>
                                </td>
                                <td style="width:4.75%;">
                                       <span>
                                        浓度
                                    </span>
                                    <span>
                                         <i class="icon-jiantou"
                                            :class="queryParam.orderName==='so2Nd'&&queryParam.order=='1' ? 'active' :''"
                                            @click="iChange('so2Nd','1')"></i>
                                        <i class="icon-jiantouxia"
                                           :class="queryParam.orderName==='so2Nd'&&queryParam.order=='0' ? 'active' :''"
                                           @click="iChange('so2Nd','0')"></i>
                                    </span>
                                </td>
                                <td style="width:4.75%;">
                                        <span>
                                        IAQI
                                    </span>
                                    <span>
                                         <i class="icon-jiantou"
                                            :class="queryParam.orderName==='so2Iaqi'&&queryParam.order=='1' ? 'active' :''"
                                            @click="iChange('so2Iaqi','1')"></i>
                                        <i class="icon-jiantouxia"
                                           :class="queryParam.orderName==='so2Iaqi'&&queryParam.order=='0' ? 'active' :''"
                                           @click="iChange('so2Iaqi','0')"></i>
                                    </span>
                                </td>
                                <td style="width:4.75%;">
                                       <span>
                                        浓度
                                    </span>
                                    <span>
                                         <i class="icon-jiantou"
                                            :class="queryParam.orderName==='no2Nd'&&queryParam.order=='1' ? 'active' :''"
                                            @click="iChange('no2Nd','1')"></i>
                                        <i class="icon-jiantouxia"
                                           :class="queryParam.orderName==='no2Nd'&&queryParam.order=='0' ? 'active' :''"
                                           @click="iChange('no2Nd','0')"></i>
                                    </span>
                                </td>
                                <td style="width:4.75%;">
                                        <span>
                                        IAQI
                                    </span>
                                    <span>
                                         <i class="icon-jiantou"
                                            :class="queryParam.orderName==='no2Iaqi'&&queryParam.order=='1' ? 'active' :''"
                                            @click="iChange('no2Iaqi','1')"></i>
                                        <i class="icon-jiantouxia"
                                           :class="queryParam.orderName==='no2Iaqi'&&queryParam.order=='0' ? 'active' :''"
                                           @click="iChange('no2Iaqi','0')"></i>
                                    </span>
                                </td>
                                <td style="width:4.75%;">
                                       <span>
                                        浓度
                                    </span>
                                    <span>
                                         <i class="icon-jiantou"
                                            :class="queryParam.orderName==='coNd'&&queryParam.order=='1' ? 'active' :''"
                                            @click="iChange('coNd','1')"></i>
                                        <i class="icon-jiantouxia"
                                           :class="queryParam.orderName==='coNd'&&queryParam.order=='0' ? 'active' :''"
                                           @click="iChange('coNd','0')"></i>
                                    </span>
                                </td>
                                <td style="width:4.75%;">
                                    <span>
                                        IAQI
                                    </span>
                                    <span>
                                         <i class="icon-jiantou"
                                            :class="queryParam.orderName==='coIaqi'&&queryParam.order=='1' ? 'active' :''"
                                            @click="iChange('coIaqi','1')"></i>
                                        <i class="icon-jiantouxia"
                                           :class="queryParam.orderName==='coIaqi'&&queryParam.order=='0' ? 'active' :''"
                                           @click="iChange('coIaqi','0')"></i>
                                    </span>
                                </td>
                                <td style="width:4.75%;">
                                       <span>
                                        浓度
                                    </span>
                                    <span>
                                         <i class="icon-jiantou"
                                            :class="queryParam.orderName==='o3Nd'&&queryParam.order=='1' ? 'active' :''"
                                            @click="iChange('o3Nd','1')"></i>
                                        <i class="icon-jiantouxia"
                                           :class="queryParam.orderName==='o3Nd'&&queryParam.order=='0' ? 'active' :''"
                                           @click="iChange('o3Nd','0')"></i>
                                    </span>
                                </td>
                                <td style="width:4.75%;">
                                        <span>
                                        IAQI
                                    </span>
                                    <span>
                                         <i class="icon-jiantou"
                                            :class="queryParam.orderName==='o3Iaqi'&&queryParam.order=='1' ? 'active' :''"
                                            @click="iChange('o3Iaqi','1')"></i>
                                        <i class="icon-jiantouxia"
                                           :class="queryParam.orderName==='o3Iaqi'&&queryParam.order=='0' ? 'active' :''"
                                           @click="iChange('o3Iaqi','0')"></i>
                                    </span>
                                </td>
                                <td style="width:5%;">
                                       <span>
                                            AQI
                                        </span>
                                    <span>
                                         <i class="icon-jiantou"
                                            :class="queryParam.orderName==='aqiAqi'&&queryParam.order=='1' ? 'active' :''"
                                            @click="iChange('aqiAqi','1')"></i>
                                        <i class="icon-jiantouxia"
                                           :class="queryParam.orderName==='aqiAqi'&&queryParam.order=='0' ? 'active' :''"
                                           @click="iChange('aqiAqi','0')"></i>
                                    </span>
                                </td>
                                <td style="width:7%;">首要污染物</td>
                                <td style="width:10%;">空气质量</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table_scrollar mCustomScrollbar _mCS_1 mCS-autoHide" style="width: 100%; height: 500px;">
                    <div id="mCSB_1" class="mCustomScrollBox tabScrollbar mCS-light mCSB_vertical mCSB_inside"
                         style="max-height: none;" tabindex="0">
                        <div id="mCSB_1_container" class="mCSB_container" style="position:relative; top:0; left:0;"
                             dir="ltr">
                            <div id="showTable" class="table_center">
                                <table class="table table-bordered table-hover info" style="font-size:12px;" border="2"
                                       v-if="data&&data.length"
                                       v-loading="loading"
                                >
                                    <tbody>
                                    <tr :bgcolor="index%2 ===0? '' :'#dce9ee'" v-for="(item,index) in data"
                                        :key="index">
                                        <td align="center" valign="middle" style="width:10.5%;">{{item.time}}</td>
                                        <td align="center" valign="middle" style="width:10.5%;">{{item.city}}</td>
                                        <td align="center" valign="middle" style="width:4.75%;">{{item.pm25Nd}}</td>
                                        <td align="center" valign="middle" style="width:4.75%;">{{item.pm25Iaqi}}</td>
                                        <td align="center" valign="middle" style="width:4.75%;">{{item.pm10Nd}}</td>
                                        <td align="center" valign="middle" style="width:4.75%;">{{item.pm10Iaqi}}</td>
                                        <td align="center" valign="middle" style="width:4.75%;">{{item.so2Nd}}</td>
                                        <td align="center" valign="middle" style="width:4.75%;">{{item.so2Iaqi}}</td>
                                        <td align="center" valign="middle" style="width:4.75%;">{{item.no2Nd}}</td>
                                        <td align="center" valign="middle" style="width:4.75%;">{{item.no2Iaqi}}</td>
                                        <td align="center" valign="middle" style="width:4.75%;">{{item.coNd}}</td>
                                        <td align="center" valign="middle" style="width:4.75%;">{{item.coIaqi}}</td>
                                        <td align="center" valign="middle" style="width:4.75%;">{{item.o3Nd}}</td>
                                        <td align="center" valign="middle" style="width:4.75%;">{{item.o3Iaqi}}</td>
                                        <td align="center" valign="middle"
                                            :style="{backgroundColor:colorjudge(item.aqiAqi)}" style="width:5%;">
                                            {{item.aqiAqi}}
                                        </td>
                                        <td align="center" valign="middle"
                                            style="vertical-align:middle; margin:0; padding:0;width:7%;">{{item.aqiOne}}
                                        </td>
                                        <td align="center" valign="middle"
                                            style="vertical-align:middle; margin:0; padding:0;width:10%;">
                                            {{item.aqiAir}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <div v-else style="text-align: center;margin: 20px 0">暂无数据</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pagination" style="text-align: right; width: 100%">
                    <el-pagination
                            size="mini"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="queryParam.page"
                            :page-size="queryParam.pageSize"
                            layout="prev, pager, next, jumper"
                            background
                            :total="pagination.total">
                    </el-pagination>
                </div>
            </div>

            <!--  <a-table :columns="columns"
                       :data-source="data"
                       :scroll="{y: 400 }"
                       :loading="loading"
                       bordered
                       :pagination="pagination"
                       :rowKey='(record, index) => index'
                       @change="handleTableChange"
              >
                  <div slot="aqiAir" slot-scope="aqiAir">
                      <div class="tag tag1" v-if="aqiAir==='优'">{{aqiAir}}</div>
                      <div class="tag tag2" v-if="aqiAir==='良'">{{aqiAir}}</div>
                      <div class="tag tag3" v-if="aqiAir==='轻度污染'">{{aqiAir}}</div>
                      <div class="tag tag4" v-if="aqiAir==='中度污染'">{{aqiAir}}</div>
                      <div class="tag tag5" v-if="aqiAir==='重度污染'">{{aqiAir}}</div>
                      <div class="tag tag6" v-if="aqiAir==='严重污染'">{{aqiAir}}</div>
                      <div class="tag tag7" v-if="aqiAir==='无数据'">{{aqiAir}}</div>
                  </div>

              </a-table>-->
        </div>
    </div>
</template>

<script>
    import url from "../utils/UrlApi"

    Date.prototype.nowDateFormat = function () { //author:
        var d = new Date()
        var year = d.getFullYear()
        var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : '' + (d.getMonth() + 1)
        var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
        var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
        var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
        var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
        // return hour + ':' + minutes + ':' + seconds
        return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds
    };
    Date.prototype.nowDayDateFormat = function () { //author:
        var d = new Date()
        var year = d.getFullYear()
        var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : '' + (d.getMonth() + 1)
        var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
        // var hour = d.getHours()  < 10 ? '0' + d.getHours() : '' + d.getHours()
        // var minutes = d.getMinutes()  < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
        // var seconds = d.getSeconds()  < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
        // return hour + ':' + minutes + ':' + seconds
        return year + '-' + month + '-' + day + ' ' + '00:00:00'
    };


    function params(obj) {
        let result = '';
        let item;
        for (item in obj) {
            if (obj[item] && String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
        if (result) {
            result = '?' + result.slice(1);
        }
        return result;
    }

    export default {
        name: "stateSite",
        data() {
            return {
                data: [],

                loading: true,
                queryParam: {
                    // timeRange: 1,   // 是否是任意范围
                    page: 1,
                    pageSize: 30,
                    type: "3", //  类型:1国控,2乡镇
                    city: localStorage.getItem('gpsState') ? JSON.parse(localStorage.getItem('gpsState')).city : '宿州市',   // 城市名
                    timeType: 1,
                    times: [new Date().nowDayDateFormat(), new Date().nowDateFormat()],
                    // times: [],
                    startTime: '', //起始时间
                    endTime: '', // 截止时间
                    orderName: '', // 排序字段
                    order: ''  //  0倒序,1正序
                },
                pagination: {
                    total: 0,
                    pageSize: 30,//每页中显示10条数据
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "50", "100"],//每页中显示的数据
                    showTotal: total => `共有 ${total} 条数据`,  //分页中显示总的数据
                },
                timeList: [
                    {label: '小时', value: 1},
                    {label: '日均', value: 2},
                    {label: '月均', value: 3},
                    {label: '季均', value: 4},
                    {label: '年均', value: 5},
                    {label: '时均值', value: 6},
                    {label: '实况值', value: 7},
                ],
                // timeRangeList: [
                //     {label: '任意范围', value: 1},
                //     {label: '非任意范围', value: 0}
                // ]
            };
        },
        created() {
            this.getSiteList()
        },
        methods: {
            getSiteList() {
                this.loading = true
                let data = this.queryParam
                if (data.times && data.times.length) {
                    data.startTime = data.times[0]
                    data.endTime = data.times[1]
                }
                this.$http.post(url.site, data).then(res => {
                    // console.log(res)
                    if (res.data.code === '200') {
                        this.loading = false
                        this.data = res.data.data.list
                        this.pagination.total = res.data.data.totalCount
                        // console.log(res)

                    } else {
                        this.$message.error(res.data.message)
                    }

                })
            },
            exportExcel() {
                let data = JSON.parse(JSON.stringify(this.queryParam))
                if (data.times && data.times.length) {
                    data.startTime = data.times[0]
                    data.endTime = data.times[1]
                    data.token = localStorage.getItem('token')
                }
                data.times = ''
                let allUrl = url.exportExcel + params(data)
                window.open(allUrl, '_blank')

            },

            // 分页切换
            handleTableChange(pagination, filters, sorter) {
                // console.log(pagination,filters,sorter)

                this.queryParam.page = pagination.current
                this.queryParam.pageSize = pagination.pageSize
                // this.queryParam.orderName = sorter.columnKey
                if (sorter.columnKey) {
                    this.queryParam.orderName = sorter.columnKey
                }
                if (sorter.order === 'ascend') {
                    this.queryParam.order = '1'
                }
                else if (sorter.order === 'descend') {
                    this.queryParam.order = '0'
                } else {
                    this.queryParam.orderName = ''
                    this.queryParam.order = ''
                }


                this.getSiteList()
            },
            //  时间切换
            onChange(params) {
                this.queryParam.startTime = params[0]
                this.queryParam.endTime = params[1]
                // console.log('params');
            },

            navTimeChange(item) {
                this.queryParam.timeType = item.value
                this.getSiteList()
            },
            navTimeRangeChange(item) {
                this.queryParam.timeRange = item.value
                this.getSiteList()
            },
            datePickerChange(value) {
                console.log(value)
                this.getSiteList()
            },

            iChange(orderName, order) {
                this.queryParam.orderName = orderName
                this.queryParam.order = order
                this.getSiteList()
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.queryParam.pageSize = val
                this.getSiteList()
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.queryParam.page = val
                this.getSiteList()
            },


            //     判断颜色
            colorjudge(value) {


                if (value <= 50) {
                    return 'green'
                }
                if (value <= 100) {
                    return 'yellow'
                }
                if (value <= 150) {
                    return 'orange'
                }
                if (value <= 200) {
                    return 'red'
                }
                if (value <= 300) {
                    return 'purple'
                }
                if (value > 300) {
                    return 'saddlebrown'
                }


            }


        },
    }
</script>

<style scoped lang="less">

    .sitePage {
        display: flex;
        flex-direction: column;
        flex: 1;
        /*min-width: 1280px;*/
        /*height: 100%;*/
        /*min-height: 600px;*/
    }

    .nav {
        display: flex;
        align-items: center;
        padding: 10px 30px;
        background-color: #fff;
        /*margin: 10px 0;*/
        .center {
            flex: 1;
        }
        .tabname {
            margin-right: 10px;
        }
        .item {
            cursor: pointer;
        }
        .timeC {
        }
        .time {
            border: 1px solid #ddd;
            padding: 3px 6px;
            border-radius: 4px;
        }
        .active {
            background-color: #bfd9e1;
        }
        .btn {
            margin: 0 5px;
        }

        .Range {
            display: flex;
            margin-left: 10px;
        }
    }

    .siteTable {
        flex: 1;
        box-sizing: border-box;
        overflow: auto;
        .tag {
            color: #fff;
            width: 100%;
            height: 100%;
            text-align: center;
            padding: 4px 0;
            border-radius: 4px;
            font-size: 10px;
        }
        .tag1 {
            background-color: green;
        }
        .tag2 {
            background-color: yellow;
            color: #000;
        }
        .tag3 {
            background-color: orange;
        }
        .tag4 {
            background-color: red;
        }
        .tag5 {
            background-color: purple;
        }
        .tag6 {
            background-color: saddlebrown;
        }
        .tag7 {
            background-color: grey;
        }
    }

    .tabletitle {
        tr {
            td {
                /*display: flex;*/
                span {
                    position: relative;
                    width: 100%;
                    left: 0;
                    i {
                        position: absolute;
                        left: 0;
                    }
                    .active {
                        color: #1daaf1;
                    }
                }
            }
        }
    }

</style>

<style scoped>
    @import "../assets/siteCss/bootstrap-responsive.min.css";
    @import "../assets/siteCss/bootstrap.min.css";
    @import "../assets/siteCss/daterangepicker-bs3.css";
    @import "../assets/siteCss/font-awesome.min.css";
    @import "../assets/siteCss/iconfont.css";
    @import "../assets/siteCss/innerStyle.css";
    @import "../assets/siteCss/jquery.mCustomScrollbar.min.css";
    @import "../assets/siteCss/multiple-select.css";
    @import "../assets/siteCss/normalize.css";
    @import "../assets/siteCss/page.css";
    @import "../assets/siteCss/table.css";

</style>